import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";

import AppMobileMenu from "../AppMobileMenu";
// import AppLogo from "../../assets/utils/images/logo-inverse.png";
// import appLightLogo from "../../assets/utils/images/logo.png";
import {
  setEnableClosedSidebar,
  setEnableMobileMenu,
  setEnableMobileMenuSmall,
} from "../../reducers/ThemeOptions";
import { getAgencyInfo, isAgentAccount } from "../../Common/Appcommon";
import { useAppContext } from "../../Context/AppContext";

const HeaderLogo = (props) => {
  /* const [active, setActive] = useState(false);
  const [mobile, setMobile] = useState(false);
  const [activeSecondaryMenuMobile, setAtiveSecondaryMenuMobile] = useState(false); */
  let appLightLogo = process.env.REACT_APP_DEFAULT_LIGHT_LOGO; //process.env.REACT_APP_LIGHT_LOGO ;
  let AppLogo = process.env.REACT_APP_DEFAULT_DARK_LOGO;//process.env.REACT_APP_DARK_LOGO;
  const [defaultLogo, setDefaultLogo] = useState("");
  const [billingName, setBillingName] = useState("");
  const { theme } = useAppContext();
  let isagent = isAgentAccount();
  useEffect(() => {
    (async () => {
      let logoField = "Logo";
      let logo = ""; //AppLogo;
      if(isagent){
        logo =  AppLogo;
      }
      if (theme === "dark-theme") {
        if(isagent){
          logo = appLightLogo;
        }
        logoField = "Dark_Logo";
      }
      let agencyLogoInfo = getAgencyInfo(logoField);
      let agencyDetails = getAgencyInfo("all");
      let Logo = agencyDetails["Logo"];
      let Dark_Logo = agencyDetails["Dark_Logo"];
      let favIcon = agencyDetails["FavIcon"];
      setBillingName(agencyDetails["Organization_Name"]);
      let agencyLogo = "";
      if (agencyLogoInfo !== "" && agencyLogoInfo !== undefined && agencyLogoInfo !== null) {
        //agencyLogo = agencyLogoInfo;
        if (agencyLogoInfo.indexOf(",") > 0) {
          let agentLArr = agencyLogoInfo.split(",");
          agencyLogo = agentLArr[1];
          logo = agencyLogo;
        }
      }
      /* if(favIcon){
        let icons = favIcon.split(',');
        logo = icons[1];
      } */
      if(Logo && theme !== "dark-theme"){
        let icons = Logo.split(',');
        logo = icons[1];
      }
      if(Dark_Logo && theme === "dark-theme"){
        let icons = Dark_Logo.split(',');
        logo = icons[1];
      }

      setDefaultLogo(logo);
    })();
    return () => {
      // this now gets called when the component unmounts
    };
  }, [theme]);

 /*  const toggleEnableClosedSidebar = () => {
    let { enableClosedSidebar, setEnableClosedSidebar } = props;
    setEnableClosedSidebar(!enableClosedSidebar);
  }; */


  return (
    <Fragment>
      <div className="app-header__logo">
        <div className="logo-src">
          <div className="logo_container d-flex justify-items-center m-auto">
            {defaultLogo && <img src={defaultLogo} alt="Logo" /> }
            {/* <div className="p-1">
              {billingName}
            </div> */}
          </div>
        </div>
      </div>
      <AppMobileMenu  mobileViewNeedLeftMenu = {props.mobileViewNeedLeftMenu}/>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
});

const mapDispatchToProps = (dispatch) => ({
  setEnableClosedSidebar: (enable) => dispatch(setEnableClosedSidebar(enable)),
  setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
  setEnableMobileMenuSmall: (enable) =>
    dispatch(setEnableMobileMenuSmall(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderLogo);
